import type { AnalyzerEntity, StepTask } from '@telespot/domain';

export const unlabeled = 'unlabeled';

export interface Coordinates {
  x0: number;
  y0: number;
  x1: number;
  y1: number;
}

export interface Roi {
  id: string;
  uuid?: string;
  cropFile?: string;
  assetId: string;
  sampleId: string;
  analysisId: string;
  pipelineStepId: string;
  pipelineId: string;
  findingType: StepTask;
  findingId: string;
  findingVersion: number;
  findingVersionId: string;
  originFindingVersionId?: string;
  coordinates: Coordinates;
  labels: Map<string, number>;
  url?: string;
  creatorEntity: AnalyzerEntity;
  creatorId: string;
  additionalLabelsIncluded: boolean;
}

export interface CountStat {
  count: number;
  percentage: number;
}

export interface LabelCounts {
  [uuid: string]: CountStat;
}

export interface MosaicItem extends Coordinates {
  id: string;
  sampleId: string;
  assetId: string;
  analysisId: string;
  type: StepTask;
  findingId: string;
  findingVersionId: string;
  creatorEntity: string;
  creatorId: string;
  stepId: string;
  pipelineId: string;
  findingVersion: number;
  x0: number;
  y0: number;
  x1: number;
  y1: number;
  label: string;
  score: number;
  cropFile?: string;
}

export interface CounterDeltas {
  labelCountDeltas: Map<string, number>;
  singleLabelDeltas: Map<string, number>;
  multiLabelDeltas: Map<string, number>;
}

export interface RoiChange {
  id: string;
  sampleId: string;
  assetId: string;
  creatorId: string;
  timestamp: number;
  labelsAdded: string[];
  labelsRemoved: string[];
  isNew?: boolean;
  snapshot?: Roi;
}
